/**
 * Test ID utilities for Table component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Table
 * @param identifier - Table identifier
 * @returns Test ID string
 */
export const setTableTestId = (identifier: string): string => generateTestId("Table", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for TableRow
 * @param identifier - Row identifier (e.g., row index or unique key)
 * @returns Test ID string
 */
export const setTableRowTestId = (identifier: string | number): string =>
  generateTestId("TableRow", String(identifier).replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for TableCell
 * @param rowId - Row identifier
 * @param colId - Column identifier
 * @returns Test ID string
 */
export const setTableCellTestId = (rowId: string | number, colId: string | number): string =>
  generateTestId("TableCell", `${rowId}-${colId}`.replace(/\s+/g, "-").toLowerCase());
